import React, { useState, useEffect } from "react";
import { connectToContract } from "./CrownContract";
import { FaMoneyBillWave } from "react-icons/fa";
import { formatEther, parseEther } from "ethers";

const LoanActions = ({ provider, account }) => {
  const [collateral, setCollateral] = useState("");
  const [durationDays, setDurationDays] = useState("");
  const [loan, setLoan] = useState(null);
  const [dailyInterestRate, setDailyInterestRate] = useState("0");
  const [maxLoanDuration, setMaxLoanDuration] = useState("0");

  useEffect(() => {
    const fetchData = async () => {
      if (!provider || !account) return;

      try {
        const contract = await connectToContract(provider);
        
        // Načtení loan dat
        const loanData = await contract.loans(account);
        setLoan({
          collateralWei: formatEther(loanData.collateralWei),
          loanAmount: formatEther(loanData.loanAmount),
          duration: loanData.duration.toString(),
          startTime: loanData.startTime.toString(),
          isActive: loanData.isActive,
        });

        // Načtení dailyInterestRate a maxLoanDuration
        const interestRate = await contract.dailyInterestRate();
        const maxDuration = await contract.maxLoanDuration();
        setDailyInterestRate((Number(interestRate) / 100).toFixed(2)); // Převod z bp na % (např. 2 -> 0.02%)
        setMaxLoanDuration((Number(maxDuration) / 86400).toFixed(0)); // Převod sekund na dny (např. 63072000 -> 730)
      } catch (error) {
        console.error("Error fetching data:", error);
        setDailyInterestRate("0");
        setMaxLoanDuration("0");
      }
    };
    fetchData();
  }, [provider, account]);

  const handleCreateLoan = async () => {
    if (!provider || !account) {
      alert("Connect your wallet first!");
      return;
    }
    if (!collateral || isNaN(collateral) || Number(collateral) <= 0) {
      alert("Please enter a valid positive collateral amount!");
      return;
    }
    if (!durationDays || isNaN(durationDays) || Number(durationDays) <= 0 || Number(durationDays) > Number(maxLoanDuration)) {
      alert(`Please enter a valid duration (max ${maxLoanDuration} days)!`);
      return;
    }
    try {
      const contract = await connectToContract(provider);
      const durationSeconds = Number(durationDays) * 86400; // Převod dní na sekundy
      const tx = await contract.createLoan(
        parseEther(collateral),
        durationSeconds,
        { value: parseEther(collateral) }
      );
      await tx.wait();
      alert("Loan created successfully!");
      const loanData = await contract.loans(account);
      setLoan({
        collateralWei: formatEther(loanData.collateralWei),
        loanAmount: formatEther(loanData.loanAmount),
        duration: loanData.duration.toString(),
        startTime: loanData.startTime.toString(),
        isActive: loanData.isActive,
      });
      setCollateral("");
      setDurationDays("");
    } catch (error) {
      console.error("Error creating loan:", error);
      alert("Loan creation failed: " + error.message);
    }
  };

  const handleRepayLoan = async () => {
    if (!provider || !account || !loan || !loan.isActive) {
      alert("No active loan to repay!");
      return;
    }
    try {
      const contract = await connectToContract(provider);
      const tx = await contract.repayLoan();
      await tx.wait();
      alert("Loan repaid successfully!");
      setLoan(null); // Reset loan state after repayment
    } catch (error) {
      console.error("Error repaying loan:", error);
      alert("Loan repayment failed: " + error.message);
    }
  };

  return (
    <div>
      <h2>
        <FaMoneyBillWave className="icon" /> Loans
      </h2>
      <p>Collateral: 1:1</p>
      <p>Daily Interest Rate: {dailyInterestRate}%</p>
      <p>Maximum Loan Duration: {maxLoanDuration} days</p>
      <div className="action-box">
        <h3>Create Loan</h3>
        <input
          type="text"
          placeholder="Collateral (ETH)"
          value={collateral}
          onChange={(e) => setCollateral(e.target.value)}
        />
        <input
          type="text"
          placeholder="Duration (days)"
          value={durationDays}
          onChange={(e) => setDurationDays(e.target.value)}
        />
        <button onClick={handleCreateLoan}>Create Loan</button>
      </div>
      {loan && (
        <div className="details-box">
          <h3>Loan Details</h3>
          <p>Collateral: {loan.collateralWei} ETH</p>
          <p>Loan Amount: {loan.loanAmount} Crown</p>
          <p>Duration: {loan.duration} seconds</p>
          <p>Start Time: {new Date(loan.startTime * 1000).toLocaleString()}</p>
          <p>Active: {loan.isActive ? "Yes" : "No"}</p>
          {loan.isActive && (
            <button onClick={handleRepayLoan}>Repay Loan</button>
          )}
        </div>
      )}
    </div>
  );
};

export default LoanActions;